import { environment as env } from 'environments/environment';

export const menuClientIdBlackList = [env.clientId, 'CRMT', 'FormsWorkflow'];